<template>
  <div class="  h-16 cursor-pointer list-group mt-2  w-full flex items-start    flex flex-row justify-center  ">
    <div class="flex flex-col items-start w-full   pt-6  px-6">
      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-sm font-medium text-gray-900 "
        >Titre</label>
        <input
          id="default-input"
          v-model="title"
          type="text"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
          @input="onInputTitle"
        >
      </div>



      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-sm font-medium text-gray-900 "
        >Description</label>
        <input
          id="default-input"
          v-model="description"
          type="text"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
          @input="onInputDescription"
        >
      </div>




      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-sm font-medium text-gray-900 "
        >Attribute</label>
        <input
          :id="`att-input-${properties?.id}`"
          v-model="attribute"
          type="text"
          class="  w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5      "
          @input="onChangeAttribute"
        >
      </div>

      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-sm font-medium text-gray-900 "
        >Format
          {{ format }} </label>
        <div class="w-full flex flex-col">
          <div
            class="inline-flex rounded-md shadow-sm w-full"
            role="group"
          >
            <button
              type="button"
              :class="{'bg-gray-50 text-gray-900 font-semibold ring-gray-300 ring-2 z-10' : (format =='date-time') , 'text-gray-700 bg-gray-200 font-medium' : (format !='date-time') , }"
              class="w-4/12 px-2 py-2 text-xs border border-gray-300 rounded-s-lg hover:bg-gray-50 hover:text-gray-900"
              @click="onClickFormat('date-time')"
            >
              Date & Heure
            </button>
            <button
              type="button"
              :class="{'bg-gray-50 text-gray-900 font-semibold ring-gray-300 ring-2 z-10' : (format == 'date') , 'text-gray-700 bg-gray-200 font-medium' : (format !='date') , }"
              class="w-4/12 px-2 py-2 text-xs font-medium   border-t border-b border-gray-300 hover:bg-gray-50 hover:text-gray-900"
              @click="onClickFormat('date')"
            >
              Date
            </button>
            <button
              type="button"
              :class="{'bg-gray-50 text-gray-900 font-semibold ring-gray-300 ring-2 z-10' : (format =='time') , 'text-gray-700 bg-gray-200 font-medium' : (format !='time') , }"
              class="w-4/12 px-2 py-2 text-xs font-medium   border border-gray-300 rounded-e-lg hover:bg-gray-50 hover:text-gray-900"
              @click="onClickFormat('time')"
            >
              Heure
            </button>
          </div>
        </div>
      </div>

      <div class="mb-6 w-full text-left">
        <label
          for="default-value-input"
          class="block mb-2 text-sm font-medium text-gray-900 "
        >Valeur par défault</label>

        <div class="w-full flex flex-row   items-center">
          <div class="flex flex-row items-center   text-left   w-72 ">
            <button
              :id="`dropdownDefaultButton-${properties?.id}`"
              :data-dropdown-toggle="`dropdownDefault-${properties?.id}`"
              class=" w-full inline-flex items-center px-4 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300   "
              type="button"
            >
              <span class="w-full text-left truncate">{{ defaultval?.name }}</span>

              <svg
                class="w-2.5 h-2.5 ms-2.5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 4 4 4-4"
                />
              </svg>
            </button>

            <!-- Dropdown menu -->
            <div
              :id="`dropdownDefault-${properties?.id}`"
              class=" w-full z-10 hidden bg-white rounded-lg shadow w-60 "
            >
              <div class="p-3">
                <label
                  for="input-group-search"
                  class="sr-only"
                >Default</label>
                <div class="relative">
                  <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                    <svg
                      class="w-4 h-4 text-gray-500 "
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 20"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                      />
                    </svg>
                  </div>
                  <input
                    id="input-group-search"
                    type="text"
                    class=" bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 pr-2.5  py-2.5 pl-6      "
                    style="padding-left:40px"
                    placeholder="Rechercher une source"
                  >
                </div>
              </div>
              <ul
                class="h-48 px-3 pb-3 overflow-y-auto text-sm text-gray-700 "
                aria-labelledby="dropdownDefaultButton"
              >
                <li
                  v-for="item in defaults"
                  :id="item.id"
                  :key="item.id"
                >
                  <div
                    class="flex items-center p-2 rounded hover:bg-gray-100 cursor-pointer"
                    @click="selectDefault(item)"
                  >
                    <label
                      class="  w-full ms-2 text-sm font-medium text-gray-900 rounded    cursor-pointer"
                    >
                      {{ item.name }}
                    </label>
                  </div>
                </li>
              </ul>
              <a
                href="#"
                class="flex items-center p-3 text-sm font-medium text-red-600 border-t border-gray-200 rounded-b-lg bg-gray-50  hover:bg-gray-100   hover:underline"
              >
                <svg
                  class="w-4 h-4 me-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 18"
                >
                  <path
                    d="M6.5 9a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM8 10H5a5.006 5.006 0 0 0-5 5v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2a5.006 5.006 0 0 0-5-5Zm11-3h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2Z"
                  />
                </svg>
                Delete user
              </a>
            </div>
          </div>
        </div>
      </div>


      <div class="hidden  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-sm font-medium text-gray-900 "
        >Affichage</label>
        <div class="w-full flex flex-row ">
          <div class="ml-3 flex items-center mb-4 w-64">
            <label
              for="default-radio-1"
              class="mr-2 text-sm font-medium text-gray-900 "
            >Type</label>

            <select
              id="radio-layout"
              v-model="layout"
              class="w-16 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
              @change="onChangeLayout"
            >
              <option value="automatic">
                Automatique
              </option>
              <option value="1-0">
                1 Colonne
              </option>
              <option value="1-1">
                2 Colonnes 50/50
              </option>
              <option value="2-1">
                2 Colonnes 66/33
              </option>
              <option value="1-2">
                2 Colonnes 33/66
              </option>
            </select>
          </div>
        </div>
      </div>


      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-sm font-medium text-gray-900 "
        >Affichage</label>

        <div class="flex flex-col">
          <div class="flex items-center me-4">
            <input
              id="inline-2-checkbox"
              v-model="isTitleDisplayed"
              type="checkbox"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
              @change="onChangeIsTitleDisplayed"
            >
            <label
              for="inline-2-checkbox"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Affichage du Titre</label>
          </div>
          <div class="flex items-center me-4">
            <input
              id="inline-2-checkbox"
              v-model="isDescriptionDisplayed"
              type="checkbox"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
              @change="onChangeIsDescriptionDisplayed"
            >
            <label
              for="inline-2-checkbox"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Affichage de la
              description</label>
          </div>
          <div class="flex items-center me-4 mt-2">
            <input
              id="inline-2-checkbox"
              v-model="isRowDisplayed"
              type="checkbox"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
              @change="onChangeIsRowDisplayed"
            >
            <label
              for="inline-2-checkbox"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Affichage sur une
              ligne</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    import { Dropdown } from 'flowbite';

    export default {
        name: 'DateTableFormComponentDetails',
        props: {
            properties: Object
        },
        data() {

            return {
                title: "",
                description: "",
                defaultval: { name: "Aucune", id: "none", value: "" },
                format: "",
                attribute: "",
                layout: "1-0",
                isRowDisplayed: false,
                isTitleDisplayed: true,
                isDescriptionDisplayed: false,
                defaults: [
                    { id: "none", name: "Aucune", value: "" },
                    { id: "now", name: "Date et Heure courrante", value: "{{now}}" }
                ],

            }
        },
        watch:
        {
            properties: function () {
                this.title = this.properties?.title;
                this.description = this.properties?.description;
                this.format = this.properties?.format;
                this.isRowDisplayed = this.properties?.layout == 'row';
                this.isTitleDisplayed = this.properties?.option?.title;
                this.isDescriptionDisplayed = this.properties?.option?.description;
                this.attribute = this.properties?.attribute;

                let def = this.findDefault(this.properties?.default)
                if (def != undefined)
                    this.defaultval = def;

                this.layout = this.properties?.layout
                if (this.layout == undefined) this.layout = "1-1"
            }
        },
        mounted() {
            this.title = this.properties?.title
            this.description = this.properties?.description
            this.isTitleDisplayed = this.properties?.option?.title;
            this.isDescriptionDisplayed = this.properties?.option?.description;

            this.format = this.properties?.format
            this.attribute = this.properties?.attribute;
            this.isRowDisplayed = this.properties?.layout == 'row';

            let def = this.findDefault(this.properties?.default)
            if (def != undefined)
                this.defaultval = def;

            this.layout = this.properties?.layout
            if (this.layout == undefined) this.layout = "1-0"

            {

                const $targetEl = document.getElementById('dropdownDefault-' + this.properties?.id);

                // set the element that trigger the dropdown menu on click
                const $triggerEl = document.getElementById('dropdownDefaultButton-' + this.properties?.id);

                // options with default values
                const options = {
                    placement: 'bottom',
                    triggerType: 'click',
                    offsetSkidding: 0,
                    offsetDistance: 10,
                    delay: 300,
                    ignoreClickOutsideClass: false,
                    //   onHide: () => {

                    //   },
                    //   onShow: () => {

                    //   },
                    //   onToggle: () => {

                    //   },
                };

                // instance options object
                const instanceOptions = {
                    id: 'dropdownSearchButton-' + this.properties?.id,
                    override: true
                };
                const dropdownDefault = new Dropdown($targetEl, $triggerEl, options, instanceOptions);
                dropdownDefault.hide()
            }
        },
        methods:
        {
            findDefault: function (val) {
                if (val == undefined) return null
                let def = this.defaults.find(function (a) { return a.value == val })
                return def
            },
            onChangeAttribute: function () {
                this.$emit("updateField", { id: this.properties?.id, tab: "properties", att: 'attribute', value: this.attribute })
            },
            onChangeIsTitleDisplayed: function () {
                this.$emit("updateField", { id: this.properties?.id, tab: "properties", att: 'option.title', value: this.isTitleDisplayed })
            },
            onChangeIsDescriptionDisplayed: function () {
                this.$emit("updateField", { id: this.properties?.id, tab: "properties", att: 'option.description', value: this.isDescriptionDisplayed })
            },

            onClickFormat: function (format) {
                this.format = format
                this.$emit("updateField", { id: this.properties?.id, tab: "properties", att: 'format', value: this.format })
            },
            onChangeLayout: function () {
                this.$emit("updateField", { id: this.properties?.id, tab: "properties", att: 'layout', value: this.layout })
            },
            onInputTitle: function () {
                this.$emit("updateField", { id: this.properties?.id, tab: "properties", att: 'title', value: this.title })
            },
            onInputDescription: function () {
                this.$emit("updateField", { id: this.properties?.id, tab: "properties", att: 'description', value: this.description })
            },
            onChangeIsRowDisplayed: function () {


                if (this.isRowDisplayed)
                    this.$emit("updateField", { id: this.properties?.id, tab: "properties", att: 'layout', value: 'row' })
                else
                    this.$emit("updateField", { id: this.properties?.id, tab: "properties", att: 'layout', value: '1-0' })
            },
            selectDefault: function (item) {

                this.defaultval = item;

                const $targetEl = document.getElementById('dropdownDefault-' + this.properties?.id);

                // set the element that trigger the dropdown menu on click
                const $triggerEl = document.getElementById('dropdownDefaultButton-' + this.properties?.id);

                // options with default values
                const options = {
                    placement: 'bottom',
                    triggerType: 'click',
                    offsetSkidding: 0,
                    offsetDistance: 10,
                    delay: 300,
                    dependency: 'no',
                    dependencyId: "",
                    ignoreClickOutsideClass: false,
                    //   onHide: () => {

                    //   },
                    //   onShow: () => {

                    //   },
                    //   onToggle: () => {

                    //   },
                };

                // instance options object
                const instanceOptions = {
                    id: 'dropdownDefaultButton-' + this.properties?.id,
                    override: true
                };
                const dropdown = new Dropdown($targetEl, $triggerEl, options, instanceOptions);
                dropdown.hide()

                this.$emit("updateField", { id: this.properties?.id, tab: "properties", att: 'default', value: this.defaultval?.value })
            },


        }
    }
</script>